module.exports = __webpack_public_path__ + "images/tradera_logo_white.b2117c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/script/components/sign-in-modal/tradera_logo_white.png
// module id = 6af21850
// module chunks = 14 15 17 18 21